import { Card, Image, message } from "antd";
import { useEffect, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import BasicLayout from "../../../components/BasicLayout";
import FallBack from "../../../components/common/FallBack/FallBack";
import Notification from "../../../components/common/Notification";
import { CustomTab } from "../../../components/common/Tab/Tab";
import { getSingleSubAssembly } from "../../../store/actions/subAssembly/subAssembly.action";

const ViewSubAssembly = (props) => {
	const subAssemblyId = +props.match.params.id;
	const dispatch = useDispatch();
	const subAssembly = useSelector((state) => state.subAssembly.subAssembly || {});
	const history = useHistory();

	const admin = useSelector((state) => state.admin.admin || []);

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	const location = useLocation();
	const softdelete = new URLSearchParams(location.search).get("soft-delete");

	useEffect(() => {
		dispatch(getSingleSubAssembly(subAssemblyId, softdelete)).catch((err) => {
			Notification("error", err, "", "topRight");
			history.push("/products/sub-assembly");
		});
	}, [dispatch, history, softdelete, subAssemblyId]);

	let data = [];
	let isOrderEmpty = Object.keys(subAssembly).length === 0;
	if (!isOrderEmpty) {
		data = [
			{ title: "Id", description: subAssembly.id },
			{
				title: "Name",
				description: subAssembly.name,
			},
			{
				title: "Code",
				description: subAssembly.code,
			},
			{
				title: "Price",
				description: subAssembly.price ? subAssembly.price : "NA",
			},
			{
				title: "Stock",
				description: subAssembly.stock ? subAssembly.stock : "NA",
			},
			{
				title: "Discount",
				description: subAssembly.discount ? `${subAssembly.discount}%` : "NA",
			},
			{
				title: "HSN/SAC Code",
				description: subAssembly?.hsnCode ? subAssembly?.hsnCode?.code : "NA",
			},
			{
				title: "Received",
				description: new Date(subAssembly.createdAt).toLocaleString(),
			},
			{
				title: "Image",
				description: (
					<div className="gallery-images">
						<div className="image-holder-container">
							<Image width={250} height={180} src={subAssembly.url} />
						</div>
					</div>
				),
			},
		];
	}

	const handleError = (error) => {
		message.error(error.message);
	};
	let operationData = {
		deletedBy: subAssembly?.deletedBy,
		updatedBy: subAssembly?.updatedBy,
		restoredBy: subAssembly?.restoredBy,
	};
	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<Card className="enqiury-detail-card" data-testid="enqiury-detail-card">
					<CustomTab
						update={
							permissionArr === "all"
								? "true"
								: permissionArr?.products?.subAssembly.filter((item) => item === "update")?.length >
								  0
								? "true"
								: false
						}
						data={data}
						operationData={operationData}
						redirectUrl={`/products/sub-assembly/update/${subAssemblyId}`}
					/>
				</Card>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default ViewSubAssembly;
